import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import Search24PlaceholderIcon from '../../../static/icons/ic_search_24.svg';
import * as Constants from '../../constants';
import { messages as m } from '../../constants/Collection';
import { messages } from '../../constants/MyStations';
import { getInDomain } from '../../domains/externalUtils';
import GridItem from '../lib/GridItem/GridItem';

/**
 * CatalogGridItem provides generalized functionality and settings for rendering
 * T3 catalog GridItems. AlbumGridItem, ArtistGridItem, PlaylistGridItem and
 * TrackGridItem all use this component for their rendering. The station grid
 * items are the only ones that do not.
 *
 * See lib/GridItem for additional available props.
 */
class AddNewStationGridItem extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    searchUIStateUpdateT3: PropTypes.func.isRequired,
    isSearchT3Enabled: PropTypes.bool,
  };

  focusSearchT3 = () => {
    const componentName = Constants.Analytics.StatsSourceComponents.SEARCH_TILE;

    this.props.searchUIStateUpdateT3({
      hasFocus: true,
      searchType: 'mainSearch',
      componentName,
    });
  };

  handleClick = () => {
    this.focusSearchT3();
  };

  render() {
    return (
      <GridItem
        itemOnclick={this.handleClick}
        mainText={this.props.intl.formatMessage(messages.addNewStation)}
        mainTextOnclick={this.handleClick}
        hasAddIcon={true}
        placeholderOnClick={this.handleClick}
        placeholderHideMetaInfo={true}
        isPlaceholder={true}
        placeholderText={this.props.intl.formatMessage(m.searchForStation)}
        placeholderIcon={Search24PlaceholderIcon}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      searchUIStateUpdateT3: getInDomain('searchT3.actions.searchUIStateUpdate', null),
    },
    dispatch,
  );
};

const enhance = compose(connect(null, mapDispatchToProps), injectIntl);

export default enhance(AddNewStationGridItem);
export { AddNewStationGridItem as PureAddNewStationGridItem };
